import { render, staticRenderFns } from "./MusculoskeletalTensionExercisesTable.vue?vue&type=template&id=0f5f4c1d&scoped=true"
import script from "./MusculoskeletalTensionExercisesTable.vue?vue&type=script&lang=js"
export * from "./MusculoskeletalTensionExercisesTable.vue?vue&type=script&lang=js"
import style0 from "./MusculoskeletalTensionExercisesTable.vue?vue&type=style&index=0&id=0f5f4c1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5f4c1d",
  null
  
)

export default component.exports